$(document).ready(function() {
     if($('.ifa-events-slider').length){
        $('.ifa-events-slider').flickity({
            cellAlign: 'center',
            wrapAround: true,
            pageDots: true
        });
    }
    if($('.ifa-banner-countdown').length){
        console.log('====2');
        
        function initializeCountdown() {
            var $countdownElement = $('.ifa-banner-countdown');
            var endTime = $countdownElement.data('countdown').replace(/-/g, "/");
            function updateCountdown() {
                var now = new Date(); 
                var nowUTC = now.toUTCString();
                var targetDate = new Date(endTime);
                var targetDateUTC = targetDate.toUTCString();
                var difference = Date.parse(targetDateUTC) - Date.parse(nowUTC);
                if (difference <= 0) {
                    $countdownElement.remove();
                } else {
                    var days = Math.floor(difference / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((difference % (1000 * 60)) / 1000);
                    
                    $countdownElement.find('.countdown-days .countdown-box').text(days);
                    $countdownElement.find('.countdown-hours .countdown-box').text(hours);
                    $countdownElement.find('.countdown-minutes .countdown-box').text(minutes);
                    $countdownElement.find('.countdown-seconds .countdown-box').text(seconds);
                }
            }
            setInterval(updateCountdown, 1000);
            updateCountdown();
        }
        
        initializeCountdown();
    }

    if($('.ifa-titanium-image-slider').length){
        $('.ifa-titanium-image-slider').flickity({
            cellAlign: 'center',
            contain: true,
            wrapAround: false,
            prevNextButtons: true,
            pageDots: false
        });
    }

    $(document).on('click', '.ifa-doctor-testimonial-item', function(){
        if($(window).width() < 769){
            return;
        }
        const index = $(this).index();
        $(this).addClass('active').siblings().removeClass('active');
        $(`.testimonial-dot:eq(${index})`).addClass('active').siblings().removeClass('active');
    });

    $(document).on('click', '.testimonial-dot', function(){
        const index = $(this).index();
        $(this).addClass('active').siblings().removeClass('active');
        $(`.ifa-doctor-testimonial-item:eq(${index})`).addClass('active').siblings().removeClass('active');
    });

    if($('.ifa-doctor-testimonial-list').length){
        $('.ifa-doctor-testimonial-list').flickity({
            cellAlign: 'center',
            wrapAround: false,
            prevNextButtons: false,
            pageDots: true,
            groupCells: true,
            watchCSS:true,
            draggable: true
        });

        function initTestimonialAccordion(){
            if($(window).width() > 1100){
                const wrapper = $('.ifa-doctor-testimonial-list');
                const wrapperWidth = wrapper.width();
                const remainingWidth = wrapperWidth - (180 * 4 + 15 * 3);
                seTestimonialSize(remainingWidth);
            }
        }
        function seTestimonialSize(width){
            $('.ifa-doctor-testimonial-item .ifa-doctor-info').css('min-width',width);
            //find tallest testimonial
            var tallest = 0;
            $('.ifa-doctor-testimonial-item').each(function(){
                var currentHeight = $(this).find('.ifa-doctor-info-inner').outerHeight();
                if(currentHeight > tallest){
                    tallest = currentHeight;
                }
            });
            $('.ifa-doctor-testimonial-item').outerHeight(tallest);
        }
        initTestimonialAccordion();
        $(window).resize(function(){
            var resizeTimer;
            clearInterval(resizeTimer);
            resizeTimer = setTimeout(function() {
                initTestimonialAccordion();
            }, 300);
        });
    }

    $(document).on('click', '.video-popup-trigger', function(e){
        e.preventDefault();
        const videoId = $(this).data('video');
        const videoEl = $('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoId + '?loop=1&autoplay=1&mute=1&playlist=' + videoId + '&iv_load_policy=3&disablekb=1&controls=0&playsinline=1&enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        $('.video-popup .popup-video').empty().html(videoEl);
        $('.video-popup').addClass('active');
    });
    $(document).on('click', '.video-popup .popup-overlay,.video-popup .popup-close', function() {
        $('.video-popup').removeClass('active');
        $('.video-popup .popup-video').empty();
    });

   

  $(document).on('click','.klaviyo-popup-trigger', function(e){
    e.preventDefault();
    const klaviyo_code = $(this).attr('data-klaviyo');
     window._klOnsite = window._klOnsite || []; 
        window._klOnsite.push(['openForm', klaviyo_code]);
  })
});